import React from 'react';
import { FormBuilder } from 'commons-ui';
import useClone from './useClone';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchemaCreate } from '../../utils/formConfig';

const CloneConfig: React.FC<{}> = () => {
	const { data, gstOfferSegmentsData, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useClone();
	FORM_FIELD_CONFIG.segmentName.renderProps.options = gstOfferSegmentsData;
	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			validationSchema={validationSchemaCreate}
		/>
	);
};

export default CloneConfig;
